import { RequestHistory } from '@/interfaces/my-profile/request-history';
import { Details } from '@/interfaces/requirement';
import { RequestHistoryService } from '@/services/request-history/request-history.service';
import { StoreState } from '@/store';
import { modalShow } from '@/store/modal/actions';
import { loaderAnimationHide, loaderAnimationShow } from '@/store/page-loader/action';
import { ofuscate } from '@/utils/obfuscation';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { OrderPipe } from 'ngx-order-pipe';

@Component({
  selector: 'app-request-status[userMdmId]',
  templateUrl: './request-status.component.html',
  styleUrls: ['./request-status.component.css'],
})
export class RequestStatusComponent {

  @Input() detailRequestShow: boolean = false;
  @Input() userEmail: string | undefined = '';
  @Input() showingDetailRequirementId: number = 0;
  @Input()
  set userMdmId(userMdmId: string) {
    this._userMdmId = userMdmId;
    this.loadingData = true;
    this.getAllRequestHistory(userMdmId);
  }
  get userMdmId(): string {
    return this._userMdmId;
  }
  _userMdmId: string = '';
  @Input() shouldShowDetailButtons: boolean = false;
  @Input() shouldShowDeleteButtons: boolean = false;

  imagesStatus: Record<string, string> = {
    PENDIENTE: 'assets/img/atencion.png',
    EN_PROCESO: 'assets/img/espera.png',
    EN_CURSO: 'assets/img/espera.png',
    SOLICITUD_ANTECEDENTES: 'assets/img/espera.png',
    RECHAZADA: 'assets/img/rechazado.png',
    APROBADA: 'assets/img/aprobado.png',
    ELIMINADO: 'assets/img/rechazado.png',
    CANCELADA: 'assets/img/rechazado.png',
  };

  allHistoryRequest: Partial<RequestHistory>[] = [];
  sortedCollection: Partial<RequestHistory>[] = [];

  historyRequestError: string = '';

  public config: any = {
    id: 'custom',
    itemsPerPage: 5,
    currentPage: 1,
    totalItems: this.allHistoryRequest.length,
  };

  modalState: boolean = true;
  /// //////////////sorting ////////////


  detailData: Partial<Details> = {};
  id: number = 0;

  loadingData: boolean = true;

  constructor(
    private historyRequestService: RequestHistoryService,
    private store: Store<StoreState>,
    private router: Router,
    private orderPipe: OrderPipe,
  ) {

  }

  formatStatus(status?: string) {
    if (status) {
      return status.toUpperCase().replace(/\s+/g, '_');
    }
    return '';
  }

  getAllRequestHistory(userId: string) {
    if (userId) {
      this.sortedCollection = [];
      this.allHistoryRequest = [];
      const requestData$ = this.historyRequestService.getAllHistory(userId);
      requestData$.subscribe({
        next: (response) => {
          this.allHistoryRequest = response;
          this.loadingData = false;
          this.allHistoryRequest = this.allHistoryRequest.slice();
          this.sortedCollection = this.orderPipe.transform(this.allHistoryRequest, 'allHistoryRequest.requestType');
        },
        error: () => {
          this.loadingData = false;
          this.allHistoryRequest = [];
          this.historyRequestError = 'Ha ocurrido un error al intentar obtener la información asociada al historial de solicitudes.';
        },
      });
    }
  }

  /// ////  ORDENAMIENTO ///////////
  order: string = '';
  // 1 -> disabled ; 2 -> asc ; 3 -> desc
  orderStatus: 1 | 2 | 3 = 1;
  reverse: boolean = false;

  setOrder(headerName: string) {
    if (this.order !== headerName) {
      this.orderStatus = 2;
      this.order = headerName;
    }
    else if (this.orderStatus < 3) {
      this.orderStatus++;
    }
    else {
      this.orderStatus = 1;
      this.order = '';
    }

    if (this.orderStatus === 3) {
      this.reverse = true;
    }
    else {
      this.reverse = false;
    }
  }

  getSortingStatusImage(orderStatus: 1 | 2 | 3, arrow: 'UP' | 'DOWN') {
    if (arrow === 'UP') {
      if (orderStatus === 2) {
        return 'assets/img/arrow_r_g.png';
      }
      return 'assets/img/arrow_b_g.png';
    }

    if (orderStatus === 3) {
      return 'assets/img/arrow_r_g.png';
    }
    return 'assets/img/arrow_b_g.png';
  }

  onShowDetail(requirementId: number | undefined) {
    if (requirementId) {
      this.showingDetailRequirementId = requirementId;
    }
  }

  onHideDetail() {
    this.showingDetailRequirementId = 0;
  }
  /// //////////modal delete/////////
  // modal eliminacion
  showModalConfirmEliminationRequest(requirementId: number | undefined) {
    if (requirementId) {
      this.store.dispatch(modalShow({
        title: '¿Estás seguro de eliminar esta solicitud?',
        text: `
      La solicitud será eliminada automáticamente si continua en eliminar solicitud. `,
        text2: 'Presiona volver para regresar a la pantalla anterior.',
        acceptButtonText: 'Eliminar Solicitud',
        actionOnAccept: () => {
          this.store.dispatch(loaderAnimationShow());
          this.historyRequestService.deleteRequest(requirementId)
            .subscribe({
              next: () => {
                this.store.dispatch(loaderAnimationHide());
                const ofuscatedData = ofuscate({ email: this.userEmail });
                this.router.navigateByUrl(`/verification/delete-result/${ofuscatedData}`);
              },
              error: () => {

                this.store.select('pageError').subscribe({
                  next: (pageConfig) => {
                    const [website, ...url] = window.location.href.split('//')[1].split('/');
                    if (pageConfig.errorType !== 'Mulesoft') {

                      this.store.dispatch(loaderAnimationHide());
                      const ofuscatedData = ofuscate({ variant: 'failure' });
                      this.router.navigateByUrl(`/verification/delete-result/${ofuscatedData}`);

                    }
                  },
                });

              },
            });
        },
      }));
    }
  }

}
